module.exports = __webpack_public_path__ + "img/TIK-PRO.16036bff.png";